const GrafanaConfig: GrafanaConf = [
	{ panelNumber: 18, height: 500, pageSection: 1 },
	{ panelNumber: 1, height: 500, pageSection: 2 },
	{ panelNumber: 17, height: 700, pageSection: 2 },
	{ panelNumber: 16, height: 400, pageSection: 3 },
	{ panelNumber: 9, height: 400, pageSection: 3 },
	{ panelNumber: 10, height: 400, pageSection: 3 },
	{ panelNumber: 19, height: 400, pageSection: 3 },
];

type GrafanaConf = Array<{
	panelNumber: number;
	height: number;
	pageSection: 1 | 2 | 3;
}>;

export default GrafanaConfig;
